import { createStyles } from "@mantine/emotion";

export const useStylesHeader = createStyles((theme) => ({
  header: {
    borderBottom: theme.customColors.headerBorder,
    ".rb-header-desktop": {
      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        display: "none",
      },
    },
    ".rb-header-mobile": {
      display: "none",
      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        display: "flex",
        justifyContent: theme.flex.justify.between,
        width: "100%",
        alignItems: "center",
      },
    },
    ".header-box": {
      paddingTop: theme.spacing.header.paddingTop,
      paddingBottom: theme.spacing.header.paddingBottom,
      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        paddingTop: theme.spacing.header.paddingTopMobile,
      },
    },
  },
  menuButton: {
    cursor: "pointer",
    color: theme.customColors.headerArrowIcon,
    '&[aria-expanded="true"]': {
      transform: "rotate(180deg)",
    },
  },
  menuButtonUser: {
    cursor: "pointer",
    ".user-menu-arrow": {
      color: theme.customColors.headerArrowIcon,
    },
    '&[aria-expanded="true"] .user-menu-arrow': {
      transform: "rotate(180deg)",
      display: "inline-block",
    },
    ".user-menu-name": {
      fontSize: theme.spacing.header.userMenuNameFontSize,
      fontFamily: theme.headings.fontFamily.primary,
    },
  },
  menu: {
    marginTop: theme.spacing.header.menuMarginTop,
  },
  quotaLimitButton: {
    textDecoration: "underline",
    ":hover": {
      textDecoration: "none",
    },
  },
  quotaLimit: {
    padding: theme.spacing.header.quotaLimitPadding,
    ".quotaStrong": {
      fontFamily: theme.headings.fontFamily.bold,
    },
    ".mantine-Divider-root": {
      borderColor: theme.customColors.black,
      marginBottom: theme.spacing.header.dividerMarginBottom,
    },
  },
  headerLeft: {
    gap: theme.spacing.header.headerLeftGap,
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      gap: theme.spacing.header.headerLeftGapMobile,
    },
  },
  headerRight: {
    gap: theme.spacing.header.headerRightGap,
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      gap: theme.spacing.header.headerRightGapMobile,
    },
  },
}));
